import React, { Component } from 'react';
import Slider from "react-slick";
import AiOptionButtonWrap from './AiOptionButtonWrap';
import {OPTION_URL,DYNAMIC_OPTION_URL,DYNAMIC_BAND_OPTION_URL} from '../constants';

function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <div
      className={className +' fa ai-next-arrow ai-fcolor-' + window.currentSite}
      onClick={onClick}
    />
  );
}
function PrevArrow(props) {
  const { className,  onClick } = props;
  return (
    <div
      className={className +' fa ai-prev-arrow ai-fcolor-' + window.currentSite}
      onClick={onClick}
    />
  );
}


class AiOption extends Component {
    // extends React.Component {
  render() {
    
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      //lazyLoad: true,
      slidesToShow: this.props.optionNumber,
      slidesToScroll: this.props.optionNumber,
      arrow:true,
      initialSlide:0,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,  
      className:'ai-options'
//      adaptiveHeight: true

    };
    //console.log('render-aioption',this.props)
    var optionSize = this.props.optionSize +'px';
    let ctwfix={'0.33':'33','0.5':'33','1':'75','0.75':'75','1.5':'150',}
    let rows = [];
    let dynamic= ['ctw','shank','rset','bset']
    var children = this.props.children
    for (let i in children) {
      let image_url;
      let image_url2;
    if (dynamic.indexOf(this.props.image_base)!== -1){
     // console.log('ctw',ctwfix[this.props.dctw],this.props.dctw)
      image_url = DYNAMIC_OPTION_URL  
         if (this.props.image_base ==='shank') {
            image_url =  this.props.ds + '-'+ ctwfix[this.props.dctw] + '-'+ this.props.head + '-' + children[i].image     
         } 
   //      else if (this.props.image_base ==='pkb') {
   //       image_url += 'pkb-'+ this.props.ds + '-'+ this.props.dctw + '-'+ this.props.head + '-'+ this.props.sh + '-' + children[i].image     
    //   } 
       else if (this.props.image_base ==='bset') {
        image_url += 'baside4-' + children[i].image     
     } 
     else if (this.props.image_base ==='rset') {
      image_url += 'side-'+  this.props.sh + '-' + children[i].image     
   } 
   else if (this.props.image_base ==='band') {
        image_url = DYNAMIC_BAND_OPTION_URL 
        if (children[i].image ==='C')
          image_url +=  this.props.bandC +'.jpg'
        else  if (children[i].image ==='S')
          image_url +=  this.props.bandS +'.jpg'
        else  if (children[i].image ==='0') {
          image_url =  OPTION_URL+ 'small/button/none.jpg'
          image_url2 =  OPTION_URL+ 'large/button/none.jpg'
        }
          
      
   }

   var today = new Date();
   var datehour = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate()+'-'+today.getHours();
   

 if (this.props.image_base ==='shank'){
   image_url2 =  OPTION_URL+ 'large/shank/'+ image_url
   image_url =  OPTION_URL+ 'small/shank/'+ image_url
  
    //image_url2 = image_url+'?s=200&time='+datehour
    //image_url = image_url+'?s=100&time='+datehour
  } 
else  if (this.props.image_base ==='ctw'){
    
    image_url2 = OPTION_URL  +'large/'+this.props.image_base + '/'+ this.props.ds.toLowerCase() +'/'+children[i].image
    image_url =  OPTION_URL  +'small/'+this.props.image_base + '/'+ this.props.ds.toLowerCase() +'/'+children[i].image
  } 
 else if (this.props.image_base !=='band')
    image_url2 = image_url+'?s=160'
 if (this.props.image_base ==='band' && children[i].image !=='0') {
           image_url2 = image_url+'?s=160&time='+datehour
           image_url = image_url+'?s=80&time='+datehour
           
         }
         
  }
      else {
      image_url = OPTION_URL  
      image_url2 = OPTION_URL  
      image_url += 'small/'
      image_url2 += 'large/'
      image_url += this.props.image_base +"/"
      image_url2 += this.props.image_base +"/"
      if (this.props.image_postfix !== ''){
        if (this.props.image_postfix ===  'ds') {
          image_url += this.props.ds +'/'
          image_url2 += this.props.ds +'/'
  
        } else {
          image_url += this.props.image_postfix +'/'
          image_url2 += this.props.image_postfix +'/'
  
        }
      }  
      image_url += children[i].image
      image_url2 += children[i].image
      }
      if (children[i].value === this.props.initialValue) 
        if (parseInt(i,10) >this.props.optionNumber) {
          settings.initialSlide = parseInt(i,10) -this.props.optionNumber + 1
  //        console.log('new setting',i,settings.initialSlide,children[i].attr)
        }

        //if (children[i].show)
      var active_view = false
      if (this.props.hasOwnProperty('active_view')) {
        active_view = children[i].active_view
      }
   //   else if (ALL_STONES.indexOf(this.props.attr) !== -1) {
   //     active_view ='1'
   //   }
      //console.log ('AIOPTION',this.props.attr,active_view,this.props)
      let prefix=undefined
      if (children[i].quality !== '') {
          prefix=children[i].quality
      }
      let name_top=''

      if (children[i].hasOwnProperty('month')) {
          name_top = children[i].month.substring(0,3).toUpperCase()
      }

      let show =true
      if (children[i].hasOwnProperty('show') && children[i].show === false)
        show = false
     // console.log('ButtonWrap',image_url,image_url2)
     
      if (show)  
       rows.push(<AiOptionButtonWrap 
        name={children[i].name} 
        nameTop={name_top} 
        namePrefix={prefix} 
        attr={this.props.attr} 
        css={this.props.css} 
        value={children[i].value} 
        show={show} 
        active_view ={active_view}
        key={this.props.attr +'-'+i.toString()} 
        style={{ float:'left',height:optionSize}}
        image={image_url}
        image2={image_url2}
        options_all={this.props.options_all}
            

        optionSize={optionSize} />);
    }
    let hr_not_last =[]
    if (this.props.last === 'false') {
      hr_not_last.push(<div className='ai-textinput-hr' key={'hr-' + this.props.attr }/>)
    //  console.log('hc not last',this.props.last)
    }
   
    var note = ''
    if (this.props.attr === 'f') {
    note =<div className='ai-input-box-bottom'>
    <div className='ai-textinput-hr'/>
    NOTE: Personalization options do not support the use of emoji or symbols. Our experts will ensure the proper size and placement of your message.
    </div>
    }
   // var sliderSize = (rows.length * this.props.optionSize) +'px';
    var maxSliderSize = (this.props.optionNumber * this.props.optionSize) +'px';
    //console.log('max',maxSliderSize);
    let fcolor ='ai-color-' + window.currentSite +' ai-option-title'
    let bcolor= this.props.optionName.replace('name','titlediv')
    if (this.props.name.toUpperCase() === 'MATCHING BAND'){
    fcolor ='ai-bcolor2-' + window.currentSite +' ai-option-title'
    bcolor = bcolor + ' ai-bcolor2-' + window.currentSite
    }
   if (rows.length<= this.props.optionNumber)
    return (
     <div  style={{width:maxSliderSize,marginLeft:'30px'}} className={'ai-option-box' + this.props.optionName}>
      <div  className={bcolor}><div className='ai-option-title-left'></div>
      <div className={fcolor+ this.props.optionName.replace('name','titleline') }>{this.props.name.toUpperCase()}</div></div>
      {rows}
      <div style={{clear:'both'}}/>
      {note}
      {hr_not_last}
    </div>
    );
   else     
    return (
      <div  style={{width:maxSliderSize,marginLeft:'30px'}} className={'ai-option-box' + this.props.optionName}>
      <div><div className='ai-option-title-left'></div><div className={fcolor}>{this.props.name.toUpperCase()}</div></div>
        <Slider {...settings} style={{width:maxSliderSize,height:optionSize}}>
        {rows}
        </Slider>
        {note}
        {hr_not_last}
      </div>
    
    );
  }
}
export default AiOption;


// WEBPACK FOOTER //
// ./src/layout/AiOption.js